import { NumberHelper } from '../helpers/NumberHelper';

class Financing {
  constructor(params) {
    this.price = params.price;
    // Locale is 'es' to enforce Spanish numbering styles.
    this.priceString = params.price ? NumberHelper.localizeNumber(params.price) : null;
    this.minimumAmount = params.minimumAmount;
    this.zeroDayExpiry = params.zeroDayExpiry ?
      Financing.buildEntry(params.zeroDayExpiry) : [];
    this.thirtyDayExpiry = params.thirtyDayExpiry ?
      Financing.buildEntry(params.thirtyDayExpiry) : [];
    this.withInitialPayment = params.withInitialPayment ?
      Financing.buildEntry(params.withInitialPayment) : [];
  }

  static buildEntry(entry) {
    return entry.map(item => ({
      amount: item.amount,
      price: item.price,
      priceString: item.price ? NumberHelper.localizeNumber(item.price) : null,
      totalPrice: item.amount * item.price,
      totalPriceString: NumberHelper.localizeNumber(item.amount * item.price),
    }));
  }
}

export { Financing };



// WEBPACK FOOTER //
// ./src/models/Financing.js